import { SetStateAction } from "react";
import createStore from "zustand";
import { Course, Lesson } from "./courseStore";
import { NextRouter } from "next/router";

export type CourseQuizStore = {
  // state
  isQuizDone: boolean;
  isTimeOut: boolean;
  step: any;
  quizNumber: number;
  isRetakeQuiz: boolean;
  showResults: boolean;
  quizScorePassedState: any;
  showAlertQuiz: boolean;
  currentLesson: Lesson;
  currentCourse: Course;
  runTimer: boolean;
  storeAnswers: string[];
  showAnswerResult: boolean;
  isCorrect: boolean;
  multipleAnswerStatus: string;

  // actions
  setIsQuizDone: (item: boolean) => void;
  setIsTimeOut: (item: boolean) => void;
  setStep: (item: SetStateAction<number>) => void;
  setNum: (item: SetStateAction<number>) => void;
  setIsRetakeQuiz: (item: SetStateAction<boolean>) => void;
  setShowResults: (item: SetStateAction<boolean>) => void;
  setQuizScorePassedState: (item: any) => void;
  setShowAlertQuiz: (item: SetStateAction<boolean>) => void;
  onCloseAlertQuiz: (router: NextRouter) => void;
  onCloseModal: (router: NextRouter) => void;
  onResumeQuiz: () => void;
  setCurrentLesson: (item: Lesson) => void;
  setCurrentCourse: (item: Course) => void;
  setRunTimer: (item: boolean) => void;
  setStoreAnswers: (item: string[] | ((prevAnswers: string[]) => string[])) => void;
  setShowAnswerResult: (item: boolean) => void;
  setIsCorrect: (item: boolean) => void;
  setMultipleAnswerStatus: (item: string) => void;
};

export const useCourseQuizStore = createStore<CourseQuizStore>((set, get) => ({
  // state
  isQuizDone: false,
  isTimeOut: false,
  step: 1,
  quizNumber: 0,
  isRetakeQuiz: false,
  showResults: false,
  quizScorePassedState: null,
  showAlertQuiz: false,
  currentLesson: {},
  currentCourse: {},
  runTimer: false,
  storeAnswers: [],
  showAnswerResult: false,
  isCorrect: false,
  multipleAnswerStatus: "default",

  // actions
  setIsQuizDone(item) {
    set({ isQuizDone: item });
  },
  setIsTimeOut(item) {
    set({ isTimeOut: item });
  },
  setStep(item) {
    set((state) => ({
      step: typeof item === "function" ? item(state.step) : item,
    }));
  },
  setNum(item) {
    set((state) => ({
      quizNumber: typeof item === "function" ? item(state.quizNumber) : item,
    }));
  },
  setIsRetakeQuiz(item) {
    set((state) => ({
      isRetakeQuiz:
        typeof item === "function" ? item(state.isRetakeQuiz) : item,
    }));
  },
  setShowResults(item) {
    set((state) => ({
      showResults: typeof item === "function" ? item(state.showResults) : item,
    }));
  },
  setQuizScorePassedState(item) {
    set({ quizScorePassedState: item });
  },
  setCurrentLesson(item) {
    set({ currentLesson: item });
  },
  setCurrentCourse(item) {
    set({ currentCourse: item });
  },
  setShowAlertQuiz(item) {
    set((state) => ({
      showAlertQuiz:
        typeof item === "function" ? item(state.showAlertQuiz) : item,
    }));
  },
  onCloseModal(router) {
    const {
      setIsRetakeQuiz,
      setShowResults,
      setNum,
      step,
      setStep,
      quizScorePassedState,
      showResults,
      currentLesson,
      setShowAlertQuiz,
      currentCourse,
    } = get();

    if (step === 0 || step === 1 || step === 3) {
      setIsRetakeQuiz(false);
      setShowResults(false);
      setNum(0);
      // trackCloseBtn();
      if (quizScorePassedState && showResults) {
        setStep(3);
      } else {
        if (currentLesson?.duration) {
          setStep(1);
        }
        setStep(2);
      }
      // TODO : onClose();
      router.push({
        pathname: "/course/[courseSlug]",
        query: {
          courseSlug: currentCourse?.slug,
          lesson: currentLesson?.slug,
        },
      });
    } else {
      setShowAlertQuiz(true);
    }
  },
  onCloseAlertQuiz(router) {
    const {
      setIsRetakeQuiz,
      setShowResults,
      setNum,
      setStep,
      quizScorePassedState,
      showResults,
      currentLesson,
      currentCourse,
    } = get();

    setIsRetakeQuiz(false);
    setShowResults(false);
    setNum(0);
    // trackCloseBtn();

    if (quizScorePassedState && showResults) {
      setStep(3);
    } else {
      if (currentLesson?.duration) {
        setStep(1);
      }
      setStep(2);
    }
    // TODO : onClose();
    router.push({
      pathname: "/course/[courseSlug]",
      query: {
        courseSlug: currentCourse?.slug,
        lesson: currentLesson?.slug,
      },
    });
  },

  onResumeQuiz() {
    const { setShowAlertQuiz } = get();
    setShowAlertQuiz(false);
  },
  setRunTimer(item) {
    set({ runTimer: item });
  },
  setStoreAnswers(item) {
    set((state) => ({
      storeAnswers: typeof item === "function" ? item(state.storeAnswers) : item,
    }));
  },
  setShowAnswerResult(item) {
    set({ showAnswerResult: item });
  },
  setIsCorrect(item) {
    set({ isCorrect: item });
  },
  setMultipleAnswerStatus(item) {
    set({ multipleAnswerStatus: item });
  }
}));
